<script lang="ts" setup>
import {Input} from 'ant-design-vue';
import {onMounted, ref, nextTick} from 'vue';
const props = defineProps<{
    value: string;
    count: number;
}>();
const emit = defineEmits<{
    (evt: 'update:value', code: string): void;
}>();
const digits = ref<number[]>([]);

const container = ref<HTMLElement>(null);

onMounted(() => {
    digits.value = Array.from({length: props.count}, () => null);
    nextTick(() => {
        const firstInput = container.value.firstElementChild as HTMLInputElement;
        firstInput?.focus();
    });
});

function isDigit(value: string) {
    return !isNaN(Number(value));
}

function onKeyDown(ev: KeyboardEvent) {
    const target = ev.target as HTMLInputElement;
    const prev = target.previousElementSibling as HTMLInputElement;
    const next = target.nextElementSibling as HTMLInputElement;
    let prevent: boolean = true;
    if (ev.key === 'v' && ev.ctrlKey) {
        return;
    }
    if (ev.key === 'Tab' || ev.key === 'Shift' || ev.key === ' ') {
        if (ev.key === 'Tab') {
            if (ev.shiftKey) {
                prev?.focus();
                prev?.select();
            } else {
                next?.focus();
                next?.select();
            }
        }
        return;
    } else if (ev.key === 'Backspace') {
        target.value = '';
        prev?.focus();
    } else if (ev.key === 'ArrowLeft') {
        prev?.focus();
        prev?.select();
    } else if (ev.key === 'ArrowRight') {
        next?.focus();
        next?.select();
    } else if (isDigit(ev.key)) {
        setTimeout(() => {
            next?.focus();
            next?.select();
        });
        if (next === null) {
            setTimeout(() => {
                emit('update:value', digits.value.join(''));
            });
        }
        prevent = false;
    } else {
        target.value = '';
    }
    if (prevent) {
        ev.preventDefault();
    }
}

function onClick(ev: MouseEvent) {
    const target = ev.target as HTMLInputElement;
    target.select();
}

function onPaste(ev: ClipboardEvent) {
    const target = ev.target as HTMLInputElement;
    const next = target.nextElementSibling as HTMLInputElement;
    const clipboardData = ev.clipboardData;
    const pastedData = clipboardData.getData('Text');
    if (isDigit(pastedData)) {
        const pastedDigits = pastedData.split('');
        console.log(pastedDigits);
        for (let i = 0; i < digits.value.length; i++) {
            const digit = pastedDigits[i];
            digits.value[i] = Number(digit);
        }
    }
}
</script>
<template>
    <span ref="container">
        <input
            v-for="(n, index) in digits.length"
            @keydown="onKeyDown"
            @click="onClick"
            @paste="onPaste"
            type="text"
            class="digit"
            maxlength="1"
            v-model="digits[n - 1]"
            v-test-id="'one-time-password' + index"
        />
    </span>
</template>
<style lang="less" scoped>
input {
    width: 36px;
    height: 48px;
    margin-right: 4px;
    border: 1px solid #d5d6de;
    border-radius: 4px;
    font-size: 24px;
    text-align: center;
}
input:nth-child(3n) {
    margin-right: 16px;
}
</style>
